import type React from 'react';
import { StarBoldOutlineFilled } from '@icons/StarBoldOutlineFilled';
import { StarBolderOutline } from '@icons/StarBolderOutline';
import { StarLineMobile } from '@icons/StarLineMobile';
import { StarSolidMobile } from '@icons/StarSolidMobile';

export interface IStar {
  value: number;
  handleHover: (value: number) => void;
  handleHoverLeave: () => void;
  handleClick: (value: number) => void;
  isFilled: boolean;
}

export const Star = ({ value, handleHover, handleHoverLeave, handleClick, isFilled }: IStar) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === ' ' || event.key === 'Enter') {
      handleClick(value);
      event.preventDefault();
    }
  };
  return (
    <span
      role="button"
      aria-hidden="true"
      className="Star inline-block md:px-2.5 md:pt-2.5 md:pb-3 sm:px-416875 sm:pt-416875 sm:pb-2"
      onMouseEnter={() => handleHover(value)}
      onMouseLeave={() => handleHoverLeave()}
      onKeyDown={handleKeyDown}
      onClick={() => handleClick(value)}
      tabIndex={0}
    >
      <div className="hidden md:block">
        {isFilled ? <StarBoldOutlineFilled /> : <StarBolderOutline />}
      </div>
      <div className="h-[1.625rem] w-[1.666875rem] block md:hidden">
        {isFilled ? <StarSolidMobile /> : <StarLineMobile />}
      </div>
      <span className="sr-only">{value}</span>
    </span>
  );
};
